module.exports = __webpack_public_path__ + "img/active_screen_time.7937c38c.svg";